import { Content } from "@/ui";
import { getRoute, getRouteObject } from "@/functions/getRoute";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { createTitle } from "@/functions/createTitle";

export default function WhitepapersPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const route = getRouteObject("whitepapers");
  const page = simple_pages_helper.find(route.id, "id");
  const children = simple_pages_helper.fetch({ parent: route.id });

  if (!page) {
    return { notFound: true };
  }

  return {
    props: {
      meta: { title: createTitle(page.title) },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Recruitment Solutions", href: getRoute("recruitment-solutions") },
              { label: page.title, href: route.url },
            ],
          },
        },
        {
          component: "Header",
          props: {
            title: page.title ?? null,
            description: page.description ?? null,
            img: page.cover_image ?? null,
          },
        },
        {
          component: "ArticleFeed",
          props: { items: children, articleType: "whitepapers" },
        },
      ],
    },
  };
}
